import * as React from 'react';
import type { Meta, StoryObj } from '@storybook/react';
import { Toggle, ToggleProps } from '../Toggle';

const meta: Meta<typeof Toggle> = {
  title: 'Components/Toggle',
  component: Toggle,
};

export default meta;
type Story = StoryObj<typeof Toggle>;

function ToggleStory(props: ToggleProps) {
  const [value, setValue] = React.useState(false);

  return <Toggle {...props} onClick={() => setValue(x => !x)} on={value} />;
}

function VariantsDisplay({ children }: { children: React.ReactNode }) {
  return <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start', flexWrap: 'wrap' }}>{children}</div>;
}

export const Default: Story = {
  render: ToggleStory,
};

export const SizeVariants: Story = {
  render() {
    return (
      <VariantsDisplay>
        <Toggle size="sm" />
        <Toggle />
      </VariantsDisplay>
    );
  },
};

export const Disabled: Story = {
  render: ToggleStory,
  args: {
    disabled: true,
  },
};

export const CustomText: Story = {
  render: ToggleStory,
  args: {
    onText: 'True',
    offText: 'False',
  },
};
